import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { format } from 'date-fns';

import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputFormTextField from 'components/atoms/GefMui/OutputFormTextField';
import { EMPTY_VALUES } from 'constants/general';
import { FIELDS } from 'features/views/productionControlDetail/notice/form';
import { equalOrThreeDashes } from 'utils';
import { joinString } from 'utils/string';

export const SingleNotice = ({ item, documentInNotFoundState }) => {
	const fullName = joinString(' ', [item?.surname, item?.firstName]);

	return (
		<Grid size={12}>
			<Grid container spacing={2}>
				<Grid size={3}>
					<TextField
						size="small"
						fieldName={FIELDS.addedNoticeFullName}
						label={getLabelMessage('productionControlDetail:noticeFullName')}
						fullWidth
						value={fullName}
						variant="standard"
						slotProps={{
							input: {
								readOnly: true,
								disableUnderline: true,
							},

							inputLabel: { shrink: !!fullName },
						}}
					/>
				</Grid>
				<Grid size={3}>
					<TextField
						size="small"
						fieldName={FIELDS.addedNoticeDateCreated}
						label={getLabelMessage('productionControlDetail:noticeDateCreated')}
						fullWidth
						value={
							item?.dateCreated ? format(new Date(item?.dateCreated), 'dd.MM.yyyy') : EMPTY_VALUES.STRING
						}
						variant="standard"
						slotProps={{
							input: {
								readOnly: true,
								disableUnderline: true,
							},

							inputLabel: { shrink: !!item?.dateCreated },
						}}
					/>
				</Grid>
				<Grid size={3}>
					{documentInNotFoundState && (
						<TextField
							size="small"
							fieldName={FIELDS.addedNoticeDocumentState}
							label={getLabelMessage('productionControlDetail:documentState')}
							fullWidth
							value={equalOrThreeDashes(item?.stateText)}
							variant="standard"
							slotProps={{
								input: {
									readOnly: true,
									disableUnderline: true,
								},

								inputLabel: { shrink: !!equalOrThreeDashes(item?.stateText) },
							}}
						/>
					)}
				</Grid>
				<Grid size={3}>
					{documentInNotFoundState && (
						<TextField
							size="small"
							fieldName={FIELDS.addedNoticeCentralConsent}
							label={getLabelMessage('productionControlDetail:centralConsent')}
							fullWidth
							value={equalOrThreeDashes(item?.finalStateText)}
							variant="standard"
							slotProps={{
								input: {
									readOnly: true,
									disableUnderline: true,
								},

								inputLabel: { shrink: !!equalOrThreeDashes(item?.finalStateText) },
							}}
						/>
					)}
				</Grid>
				<Grid size={12}>
					<OutputFormTextField
						size="small"
						fieldName={FIELDS.addedNoticeTextContent}
						label={getLabelMessage('productionControlDetail:notice')}
						fullWidth
						multiline
						value={equalOrThreeDashes(item?.notice)}
						slotProps={{
							inputLabel: {
								shrink: !!equalOrThreeDashes(item?.notice),
							},
						}}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

SingleNotice.propTypes = {
	documentInNotFoundState: PropTypes.bool,
	item: PropTypes.object,
};

export default SingleNotice;
